function zpInitReveal() {
  var els = document.querySelectorAll('.zp-reveal:not(.zp-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('zp-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('zp-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function zpInitCountUp() {
  var els = document.querySelectorAll('[data-zp-count]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-zp-count')) || 0;
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var value = Math.floor(progress * target);
        el.textContent = value.toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toLocaleString();
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function zpInitGaleria(root) {
  var main = root.querySelector('[data-zp-galeria-principal]');
  var thumbs = root.querySelectorAll('[data-zp-galeria-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (!src) return;
      main.src = src;
      main.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('zp-thumb-activo'); });
      thumb.classList.add('zp-thumb-activo');
    });
  });
}

function zpInitVariantes(root) {
  var form = root.querySelector('[data-zp-form-producto]');
  if (!form) return;
  var variantsJson = root.querySelector('[data-zp-variantes-json]');
  if (!variantsJson) return;
  var variants;
  try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

  var grupos = root.querySelectorAll('[data-zp-opcion-grupo]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = root.querySelector('[data-zp-precio]');
  var precioCompareEl = root.querySelector('[data-zp-precio-comparado]');
  var botonEl = root.querySelector('[data-zp-boton-comprar]');
  var agotadoTexto = botonEl ? botonEl.getAttribute('data-texto-agotado') : 'Agotado';
  var disponibleTexto = botonEl ? botonEl.getAttribute('data-texto-disponible') : 'Añadir al carrito';

  function moneyFormat(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function valorDeGrupo(grupo) {
    var select = grupo.querySelector('[data-zp-opcion]');
    if (select) return select.value;
    var botonActivo = grupo.querySelector('[data-zp-opcion-boton].zp-color-boton--activo');
    return botonActivo ? botonActivo.getAttribute('data-valor') : null;
  }

  function encontrarVariante() {
    var seleccion = Array.prototype.map.call(grupos, valorDeGrupo);
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = moneyFormat(variante.price);
    if (precioCompareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioCompareEl.textContent = moneyFormat(variante.compare_at_price);
        precioCompareEl.style.display = '';
      } else {
        precioCompareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      botonEl.disabled = !variante.available;
      botonEl.textContent = variante.available ? disponibleTexto : agotadoTexto;
    }
  }

  grupos.forEach(function (grupo) {
    var select = grupo.querySelector('[data-zp-opcion]');
    if (select) select.addEventListener('change', actualizar);
    var botones = grupo.querySelectorAll('[data-zp-opcion-boton]');
    botones.forEach(function (boton) {
      boton.addEventListener('click', function () {
        botones.forEach(function (b) {
          b.classList.remove('zp-color-boton--activo');
          b.setAttribute('aria-pressed', 'false');
        });
        boton.classList.add('zp-color-boton--activo');
        boton.setAttribute('aria-pressed', 'true');
        actualizar();
      });
    });
  });
  actualizar();
}

function zpInitCarrusel(root) {
  var track = root.querySelector('[data-zp-carrusel-track]');
  if (!track) return;
  var prev = root.querySelector('[data-zp-carrusel-prev]');
  var next = root.querySelector('[data-zp-carrusel-next]');
  var paso = function () {
    var card = track.querySelector('.zp-resena-card');
    return card ? card.offsetWidth + 20 : 320;
  };
  if (next) next.addEventListener('click', function () { track.scrollBy({ left: paso(), behavior: 'smooth' }); });
  if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -paso(), behavior: 'smooth' }); });
}

document.addEventListener('DOMContentLoaded', function () {
  zpInitReveal();
  zpInitCountUp();
  document.querySelectorAll('[data-zp-galeria]').forEach(zpInitGaleria);
  document.querySelectorAll('[data-zp-producto]').forEach(zpInitVariantes);
  document.querySelectorAll('[data-zp-carrusel]').forEach(zpInitCarrusel);
});
